<template>
  <div class="header">
    <div class="containr clearfix">
      <div class="logo fl">
        <router-link :to="{path: '/'}">
          <img src="../assets/img/logo.png" srcset="../assets/img/logo@2x.png 2x">
        </router-link>
      </div>
      <div class="langBox fr" @mouseleave="showLangList = false">
        <div @click.stop="showLangList = !showLangList" class="langBtn">
          <span v-if="$i18n.locale == 'en'">EN</span>
          <span v-if="$i18n.locale == 'zh'">中文</span>
          <span v-if="$i18n.locale == 'ko'">한글</span>
        </div>
        <div v-show="showLangList" class="langList">
          <div class="whiteBg">
            <div class="langItem" v-show="!($i18n.locale == 'en')" @click="changeLang('en')">EN</div>
            <!-- <div class="langItem" v-show="!($i18n.locale == 'zh')" @click="changeLang('zh')">中文</div> -->
            <div class="langItem" v-show="!($i18n.locale == 'ko')" @click="changeLang('ko')">한글</div>
          </div>
        </div>
      </div>
      <a class="fr whitePaper" :href="whitePaper[$i18n.locale]" target="__blank">Whitepaper</a>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      showLangList: false,
      whitePaper: {
        en: 'http://d1u6eqogwsdivn.cloudfront.net/whitepaper/acorn_EN_20221229.pdf',
        zh: 'http://d1u6eqogwsdivn.cloudfront.net/whitepaper/acorn_CN_20221229.pdf',
        ko: 'http://d1u6eqogwsdivn.cloudfront.net/whitepaper/acorn_KR_20221229.pdf'
      }
      // whitePaper: {
      //   zh: '/static/acorn_CN_20221229.pdf',
      //   ko: '/static/acorn_KR_20221229.pdf',
      //   en: '/static/acorn_EN_20221229.pdf'
      // }
    }
  },
  methods: {
    changeLang (lang) {
      console.log(lang)
      this.$i18n.locale = lang
      this.showLangList = false
    }
  }
}
</script>
<style lang="less" scoped>
.header{
  width: 100%;
  height: 60px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  .containr{
    padding-left: 80px;
    padding-right: 80px;
    .logo{
      width: 112px;
      padding-top: 13px;
    }
    .whitePaper {
      margin-top: 21px;
      margin-right: 60px;
      color: rgba(255, 255, 255,1);
      font-family: GothamPro-Bold, GothamPro;
      font-weight: bold;
      &:hover {
          color: #1dbf77;
        }
    }
    .langBox{
      position: relative;
      margin-top: 21px;
      .langBtn{
        span{
          font-size: 16px;
          font-family: GothamPro-Bold, GothamPro;
          font-weight: bold;
          color: rgba(255,255,255,1);
          line-height: 19px;
          cursor: pointer;
          &:hover {
              color: #1dbf77;
            }
        }
      }
      .langList{
        position: absolute;
        top: 19px;
        right: 0;
        padding-top: 20px;
        .whiteBg{
          width: 160px;
          background: #FFFFFF;
          box-shadow: 0px 16px 40px 0px rgba(51, 61, 70, 0.2);
          text-align: center;
          padding-top: 20px;
          padding-bottom: 1px;
          .langItem{
            font-size: 16px;
            font-family: GothamPro-Bold, GothamPro;
            font-weight: bold;
            color: #333D46;
            line-height: 19px;
            margin-bottom: 20px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
@media screen and (max-width:760px){
  .header{
    .containr{
      padding-left: 20px;
      padding-right: 20px;
      .logo{
        width: 99px;
        padding-top: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue